export const BankAuthorizations = {
  Authorize: 'Authorize',
  BatchId: 'Batch id',
  AuthorizationState: 'Authorization state',
  PaymentsCount: 'Payments count',
  TotalAmount: 'Total amount',
};
